// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2DUUt","header":"MergedInvoice_header__1yopn"};